import React from 'react';
import { FormattedMessage } from 'react-intl';

export const OFFER_PAYMENT_METHODS = {
  BANK: 'BANK',
  CHEQUE: 'CHEQUE',
  FINANCING: 'FINANCING',
  LEASING: 'LEASING'
};

export const OFFER_STATUS = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  CONFIRMED: 'CONFIRMED',
  DELETED: 'DELETED'
};

export const FILTERS = {
  FUEL: 'fuel',
  TRANSMISSION: 'transmission',
  BODY: 'body',
  TEXT: 'text'
};

export const FUEL_OPTIONS = [
  { value: '', label: <FormattedMessage id="all" defaultMessage="All" /> },
  { value: 'D', label: <FormattedMessage id="fuels.DIESEL" defaultMessage="Diesel" /> },
  { value: 'U', label: <FormattedMessage id="fuels.PETROL" defaultMessage="Petrol" /> },
  { value: 'H', label: <FormattedMessage id="fuels.HYBRID" defaultMessage="Hybrid" /> },
  { value: 'E', label: <FormattedMessage id="fuels.ELECTRIC" defaultMessage="Electric" /> }
];

export const TRANSMISSION_OPTIONS = [
  { value: '', label: <FormattedMessage id="all" defaultMessage="All" /> },
  { value: 'M', label: <FormattedMessage id="transmissions.manual" defaultMessage="Manual" /> },
  { value: 'A', label: <FormattedMessage id="transmissions.auto" defaultMessage="Automatic" /> }
];

export const BODY_OPTIONS = [
  { value: '', label: <FormattedMessage id="all" defaultMessage="All" /> },
  { value: 'D', label: <FormattedMessage id="carBody.three_door" defaultMessage="3d" /> },
  { value: 'H', label: <FormattedMessage id="carBody.five_door" defaultMessage="5d" /> },
  { value: 'E', label: <FormattedMessage id="carBody.clipper" defaultMessage="Clipper" /> },
  { value: 'G', label: <FormattedMessage id="carBody.utility" defaultMessage="Commercial vehicles" /> }
];
